import React from 'react'
import { Helmet } from 'react-helmet'
import Media from 'sb-media'
import { string, links } from 'common/helpers'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { useEffect } from 'sb-hooks'
import useGlobals from 'sb-hooks/useGlobals'

import Text from 'components/_new/typography/Text/Text'

import ExceptMobile from './ExceptMobile/ExceptMobile'
import Mobile from './Mobile/Mobile'

import messages from './messages'


const getItems = (fragrances, values) => {
  if (!(values.productIds instanceof Array)) {
    return fragrances
  }

  return fragrances.filter(({ id }) => values.productIds.includes(String(id)))
}

const CommonPage = (props) => {
  const {
    gender, values, isLoggedIn,
    meta, title,
    productReviews, products, brands, notes, tags,
  } = props
  let { pathname, description } = props

  const { isBot } = useGlobals(({ globals }) => ({ isBot: globals.device.isBot }))

  const isPerfumesMatched = /^\/(perfumes|colognes)/.test(pathname)

  useEffect(() => {
    if (isLoggedIn && isPerfumesMatched) {
      actions.models.router.push(
        gender === 'male'
          ? links.subscription.colognes
          : links.subscription.perfumes
      )
    }
  }, [])

  const iaNAPage = /na-(perfumes|colognes)/.test(pathname)
  let pageIndex = 0

  if (iaNAPage && /\/\d+$/.test(pathname)) {
    pageIndex = pathname.replace(/^.+\//, '')
    pathname  = pathname.replace(/\/\d+$/, '')
  }

  const items = getItems(products, values)

  // TODO add rest/seo/data on SSR
  const textDescription = props.textDescription || description

  // ductape for 'kate-spade' brand
  const isDescriptionVisible = !pathname.includes('kate-spade')

  const hasRating     = items && items.length && items[0].rating !== null
  const hasReviews    = Boolean(items && items.length && items[0].reviewsCount)

  const ratedItems    = Boolean(items && items.length && hasRating) ? items.filter((item) => item.rating !== 0) : []
  const ratingSum     = ratedItems.reduce((result, { rating }) => result + parseInt(rating, 10), 0)
  const averageRating = ratedItems.length ? Math.round(ratingSum / ratedItems.length * 100) / 100 : undefined

  const totalReviews  = items.reduce((result, item) => result + item.reviewsCount, 0)

  const ratingValue   = hasRating ? String(averageRating) : undefined
  const ratingCount   = String(ratedItems.length || 0)
  const reviewCount   = hasReviews ? String(totalReviews) : undefined

  const googleJsonData = {
    '@context': 'http://schema.org',
    '@type': 'Product',

    url: meta.href,
    name: meta.name,
    category: meta.category,

    offers: {
      '@type': 'Offer',
      priceCurrency: 'USD',
      price: '14.95',
      availability: 'http://schema.org/InStock',
    },

    aggregateRating: {
      '@type': 'AggregateRating',
      bestRating: '5',
      ratingValue,
      ratingCount,
      reviewCount,
    },
  }

  if (isDescriptionVisible) {
    description = (
      <div>
        <div dangerouslySetInnerHTML={{ __html: textDescription }} /><br />
        <Text message={messages.rating} values={{ ratingValue, ratingCount, reviewCount }} />
      </div>
    )
  }

  const metadata = {
    placement: 'seo page',
  }

  const snowplowMetadata = {
    placement: 'seo page feed',
  }

  return (
    <div>
      <Helmet
        title={`${meta.title} | Scentbird.com`}
        meta={[
          { name: 'description', content: meta.description ? string.multiLineToOneLine(meta.description) : '' },
          { name: 'keywords', content: meta.keywords },
        ]}
      >
        <script type="application/ld+json">
          {JSON.stringify(googleJsonData)}
        </script>
      </Helmet>
      <Media mobile>
        {
          (isMobile) => React.createElement(isMobile ? Mobile : ExceptMobile, {
            pathname,
            gender,
            title,
            description,
            brands,
            notes,
            tags,
            items,
            isDescriptionVisible,
            pageIndex,
            productReviews,
            brandName: values.name,
            productsAtPage: isBot ? 1000 : 50,
            metadata,
            snowplowMetadata,
          })
        }
      </Media>
    </div>
  )
}


export default connect({
  pathname: 'routing.location.pathname',
  isLoggedIn: 'models.me.isLoggedIn',
})(CommonPage)
